import { FC } from "react";
import { Layout } from "../../components/UI/Layout";
import { LanguageSwitcher } from "../../i18n/LanguageSwitcher";
import { About } from "../../pages/About";
import { ColorPage } from "../../pages/ColorPage";
import { Color } from "../../pages/Comment";
import { Editor } from "../../pages/Editor";
import { Loading } from "../../pages/Loading";
import { Message } from "../../pages/Message";
import { Stage } from "../../pages/Stage";
import styles from "./Router.module.css";
import { RouterState, useRouterContext } from "./routerContext";
import { useBootstrap } from "./useBootstrap";



export const Router: FC = () => {


    /** Stav routeru interní */
    const router = useRouterContext();

    /** Bootstrap aplikace */
    useBootstrap();

    console.log( router.state );

    return <article className={styles.container}>

            <header className={styles.header}>
                <nav>
                    {/*<button onClick={() => router.showAbout()}>{t(T.about)}</button> */}
                    <LanguageSwitcher />
                </nav>
            </header>
            <main className={styles.main}>

                <Layout>

                    {router.state === RouterState.MESSAGE && (
                        <Message />    
                    )}

                    {router.state === RouterState.LOADING && (
                        <Loading />
                    )}

                    {router.state === RouterState.ABOUT && (
                        <About />
                    )}

                    {router.state === RouterState.STAGE && (
                        <Stage />
                    )}

                    {router.state === RouterState.EDITOR && (
                        <Editor />
                    )}

                    {router.state === RouterState.COLOR && (
                        <ColorPage />
                    )}

                    {router.state === RouterState.COMMENT && (
                        <Color />
                    )}

                </Layout>
            </main>



        </article>

}